<template>
  <v-row
    dense
  >
    <template v-if="trip.photoAlbum">
      <v-col
        v-if="!client || client.loading"
        class="text-center"
      >
        <v-progress-circular
          color="primary"
          indeterminate
        />
      </v-col>

      <v-col
        v-for="photo in photos"
        :key="photo.id"
        class="d-flex child-flex"
        cols="4"
        md="3"
        lg="2"
        xl="1"
      >
        <v-card
          flat
          tile
          class="d-flex"
        >
          <v-img
            :src="`${photo.baseUrl}=w800-h800`"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                />
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-col>
    </template>

    <template v-else-if="canEdit">
      <v-col>
        <album-picker
          v-for="credential in allCredentials"
          :key="`cred-${credential.id}`"
          :integration="credential"
          block
          depressed
          color="primary"
          large
          @pick="onAlbumPicked"
        />

        <v-divider
          v-if="allIntegrations.length"
          class="my-8"
        />

        <button-connect-account
          v-for="integration in allIntegrations"
          :key="`int-${integration.id}`"
          :integration="integration"
          block
          depressed
          color="accent"
          large
        />
      </v-col>
    </template>

    <template v-else>
      <v-col class="text-center">
        This trip has no photos
      </v-col>
    </template>
  </v-row>
</template>

<script>
import AlbumPicker from '@/components/AlbumPicker'
import ButtonConnectAccount from '@/components/ButtonConnectAccount'
import { firestore, functions } from '@/plugins/firebase'
import { getIntegration, getIntegrationsByCategory } from '@/components/integrations'
import TripMixin from '@/components/TripMixin'
import GooglePhotoClient from '@/integrations/GooglePhotoClient'

export default {
  name: 'TripGallery',
  components: {
    AlbumPicker,
    ButtonConnectAccount
  },
  mixins: [ TripMixin ],
  data () {
    return {
      allCredentials: [],
      allIntegrations: [],
      client: null,
      photos: []
    }
  },
  async mounted () {
    if (this.trip.photoAlbum) {
      await this.fetchCredentials()
      this.fetchPhotos()
    } else {
      this.allIntegrations = getIntegrationsByCategory('photo')
      await this.fetchCredentials()
    }
  },
  methods: {
    async fetchCredentials () {
      const refreshToken = functions.httpsCallable('integrationsRefreshToken')

      const integrations = await firestore
        .collection('integrations')
        .where('createdBy', '==', this.$currentUser.id)
        .get()

      for (const doc of integrations.docs) {
        const credential = doc.data()
        const integration = getIntegration(credential.provider)

        if (integration.category === 'photo') {
          integration.accessToken = credential.expiresAt > new Date().getTime()
            ? credential.accessToken
            : (await refreshToken({ provider: credential.provider })).result

          this.allCredentials.push(integration)
          this.allIntegrations = this.allIntegrations.filter(i => i.id !== integration.id)
        }
      }
    },
    async fetchPhotos () {
      const [ provider, albumId ] = this.trip.photoAlbum.split('://')
      const integration = this.allCredentials.find(i => i.id === provider)

      this.client = new GooglePhotoClient(integration.accessToken)
      this.photos = await this.client.listAlbumContent(albumId)
    },
    async onAlbumPicked (albumURI) {
      this.trip.photoAlbum = albumURI
      await this.trip.save()

      this.fetchPhotos()
    }
  }
}
</script>
